import actions from "actions/actionTypes";

export const apiRequestSuccessAction = response => ({
  type: actions.API_REQUEST_SUCCESS,
  payload: response
});

export const apiRequestFailureAction = response => ({
  type: actions.API_REQUEST_FAILURE,
  payload: response
});
